export function serializeQueryParams(obj: any = {}, { delimiter = "&" } = {}) {
  if (Object.keys(obj).length === 0) {
    return "";
  }
  let query = "?";
  for (const prop in obj) {
    if (Array.isArray(obj[prop])) {
      obj[prop].forEach((el: any, index: any) => {
        query += `${prop}[${index}]=${el}${delimiter}`;
      });
    } else if (obj[prop]) {
      query += `${prop}=${encodeURI(obj[prop])}${delimiter}`;
    }
  }
  return query.slice(0, -1);
}
